module.exports = __webpack_public_path__ + "static/dcc-b64b6feae6358f450a3178a0f2ff9bee.png";